module.exports = __webpack_public_path__ + "img/borescope_protoype2 copy.fc32528b.png";